const factorName = (f) =>
  f?.factorname || f?.factor_name || `Factor ${f?.factorid ?? f?.factor_id ?? ''}`.trim();

/**
 * Lists the factors currently selected for the reservation, by name only.
 * Amounts are deliberately not shown here: they are already part of the room
 * price, tax and total, and the backend resolves them from the database.
 *
 * Discount-type factors are hidden from the UI here — they are represented by
 * the "Special Rate Applied" indicator elsewhere. The backend still receives
 * them because this component is display-only; it does not modify `factors`
 * or `fallbackSelected`.
 */
const FactorsPanel = ({ factors, fallbackSelected = [] }) => {
  const rawSelected = factors?.selected_factors || fallbackSelected;

  // UI-only filter — do not mutate the underlying data.
  const selected = (rawSelected || []).filter(
    (f) => f?.factor_type !== 'discount' && f?.factorType !== 'discount'
  );

  if (!selected || selected.length === 0) return null;

  return (
    <div className="mt-3 mb-2 rounded-md">
      <p className="text-xs font-semibold text-gray-700 mb-1">Selected Add-ons</p>
      {selected.map((f, i) => (
        <p key={`factor-${f?.factorid ?? f?.factor_id ?? i}`} className="text-xs text-gray-600">
          • {factorName(f)}
        </p>
      ))}
    </div>
  );
};

export default FactorsPanel;
